import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { FormGroup } from '@angular/forms';
import { addRemoveError, getControl, getGroup } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';
import { toNum } from '@shared/helpers/math.helper';
import { contribBiennaleCkHelper, dataCalcoloPenalitaHelper } from './helpers/contrib-biennale-form.helpers';
import { DATE_NOT_ALLOWED, REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { MyAllElemLiquidatoriEntity } from '../../../models/interfaces/revisione.interface';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { isAfter } from 'date-fns';
import { isEqual } from 'lodash-es';

export const contribBiennaleEdiliziaDateRules: FormGroupRules = {
    my_CkAvviatoProgrammaRealizzazione: (form: FormGroup) => {
        const schedaCoopEdilGroup = getGroup(form, formPaths.schedaCoopEdil);
        const my_CkAvviatoProgrammaRealizzazioneControl = getControl(schedaCoopEdilGroup, 'my_CkAvviatoProgrammaRealizzazione');
        const my_numProgEdRealizz = toNum(getControl(schedaCoopEdilGroup, 'my_numProgEdRealizz')?.value);
        const my_ScEdilObbl = toNum(getControl(schedaCoopEdilGroup, 'my_ScEdilObbl')?.value);
        const showError = my_ScEdilObbl === 1 && my_CkAvviatoProgrammaRealizzazioneControl?.value === '0' && my_numProgEdRealizz > 0;
        const errors = my_CkAvviatoProgrammaRealizzazioneControl.errors ? my_CkAvviatoProgrammaRealizzazioneControl.errors : {};

        addRemoveError(showError, errors, 'my_CkAvviatoProgrammaRealizzazione', {
            status: 'Incoerente con il numero di programmi realizzati',
        });

        contribBiennaleCkHelper(form, 'my_CkAvviatoProgrammaRealizzazione', 'my_ScEdilObbl', 1, formPaths.schedaCoopEdil);
    },

    my_DataAssembleaLiquidazVolontaria: (form: FormGroup) => {
        const amministrazioneControlloGroup = getGroup(form, formPaths.ammControllo);
        const my_DataAssembleaLiquidazVolontariaControl = getControl(amministrazioneControlloGroup, 'my_DataAssembleaLiquidazVolontaria');
        const allElemLiquidator: MyAllElemLiquidatoriEntity[] = getControl(amministrazioneControlloGroup, 'my_AllLiquidatori.my_AllElemLiquidatori')?.value;
        const showRequiredError = isNilOrEmpty(my_DataAssembleaLiquidazVolontariaControl?.value) && !!allElemLiquidator?.length;
        const showInvalidDateError = isAfter(new Date(my_DataAssembleaLiquidazVolontariaControl?.value), new Date('06/06/2079'));
        const errors = my_DataAssembleaLiquidazVolontariaControl.errors ? my_DataAssembleaLiquidazVolontariaControl.errors : {};

        addRemoveError(showRequiredError, errors, 'my_DataAssembleaLiquidazVolontaria', {
            status: REQUIRED_STATUS,
        });

        addRemoveError(showInvalidDateError, errors, 'my_DataAssembleaLiquidazVolontaria', {
            status: DATE_NOT_ALLOWED,
        });

        my_DataAssembleaLiquidazVolontariaControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_dataCalcoloPenalita: (form: FormGroup) => {
        dataCalcoloPenalitaHelper(form, 'my_dataCalcoloPenalita');
    },
};
